module.exports = __webpack_public_path__ + "img/box_pro_two_3.3d28ffcb.jpg";